module.exports = __webpack_public_path__ + "static/multipleImg-ab6ddb37fdd503286e30b43c8cd1464d.png";